import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getSplitSupplyContract } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetSplitSupplyContractRequestSchema,
  type GetSplitSupplyContractResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 分割供給契約 1 件 (基本パターンを含む) の取得 hook。 Edit モーダルの form 初期値に使う。
 * 供給地点特定番号が undefined または空文字の場合は query を無効化する。
 */
export function useGetSplitSupplyContract(
  supplyPointSpecificNumber: string | undefined,
): UseQueryResult<GetSplitSupplyContractResponse, ConnectError> {
  return useQuery(
    getSplitSupplyContract,
    create(GetSplitSupplyContractRequestSchema, {
      supplyPointSpecificNumber: supplyPointSpecificNumber ?? '',
    }),
    {
      enabled:
        supplyPointSpecificNumber !== undefined &&
        supplyPointSpecificNumber !== '',
      // 本番の既定は throwOnError: true (ErrorBoundary へ伝播)。 モーダル内で失敗を案内するため伝播させない
      throwOnError: false,
    },
  )
}
